export function displayScreenPath(
  venueCode: string | undefined,
  slug: string | null,
  token: string,
) {
  return venueCode && slug
    ? `/tv/${encodeURIComponent(venueCode)}/${encodeURIComponent(slug)}`
    : `/display/screen/${encodeURIComponent(token)}`;
}
